import { initializeApp } from 'firebase/app';
import { getAnalytics, logEvent, isSupported } from 'firebase/analytics';
import { isMobileDevice } from './utils/isMobileDevice';

const firebaseConfig = {
  apiKey: 'AIzaSyApkEnLIVgsyrZ_5kpbx1P2olyuUlW-lCM',
  authDomain: 'junaid-portfolio-3b647.firebaseapp.com',
  projectId: 'junaid-portfolio-3b647',
  storageBucket: 'junaid-portfolio-3b647.firebasestorage.app',
  messagingSenderId: '1006730774042',
  appId: '1:1006730774042:web:17f92214dc835e896073a3',
  measurementId: 'G-W8W3ST0J6J',
};

const app = initializeApp(firebaseConfig);

let analytics = null;

if (!isMobileDevice()) {
  isSupported()
    .then((supported) => {
      if (supported) {
        analytics = getAnalytics(app);
      }
    })
    .catch((err) => {
      console.warn('Firebase Analytics is not supported in this environment:', err);
    });
}

export const logCustomEvent = (eventName, params = {}) => {
  if (analytics) {
    logEvent(analytics, eventName, params);
  } else if (process.env.NODE_ENV === 'development') {
    console.log(`[Analytics Event (Dry Run)]: ${eventName}`, params);
  }
};

export { app, analytics };
